import {
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
  ChangeDetectionStrategy,
} from "@angular/core";
import { FeatureService } from "../../services/feature/feature.service";
import { Feature } from "../../interfaces/feature";

@Component({
  selector: "app-epic-selector",
  templateUrl: "./epic-selector.component.html",
  styleUrls: ["./epic-selector.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EpicSelectorComponent implements OnInit, AfterViewInit {
  @Input() themes;
  @Input() item;
  @Input() epicId;
  @Output() itemChange = new EventEmitter<Feature>();
  @Input() callLocation;
  @ViewChild("dropdown") dropdown;

  constructor(private featureService: FeatureService) {}

  /**
   * initializes dropdown menus manually after dom-tree has been rendered
   */
  ngAfterViewInit(): void {
    jQuery(".dropdown-button").dropdown({
      inDuration: 300,
      outDuration: 225,
      constrainWidth: false, // Does not change width of dropdown to that of the activator
      hover: false, // Activate on hover
      gutter: 0, // Spacing from edge
      belowOrigin: true, // Displays dropdown below the button
      alignment: "right", // Displays dropdown with edge aligned to the left of button
      stopPropagation: false, // Stops event propagation
    });
  }

  ngOnInit() {}

  /**
   * changes the selected theme by its id of actual item and saves it
   * @param themeId
   */
  async changeThisTheme(themeId) {
    this.item.epicId = themeId;
    await this.featureService.saveFeature(this.item);
    if (themeId === null) {
      delete this.item.epicId;
    }
    this.itemChange.emit(this.item);
  }

  /**
   * returns theme color by its id
   * @param themeId
   * @returns {any}
   */
  getThemeColorById(themeId) {
    if (!themeId || themeId === "undefined") {
      return "#f5f5f5";
    } else {
      return this.themes[this.getThemeIndexById(themeId)].color;
    }
  }

  getTextColor(backColor) {
    const color =
      backColor.charAt(0) === "#" ? backColor.substring(1, 7) : backColor;
    const r = parseInt(color.substring(0, 2), 16); // hexToR
    const g = parseInt(color.substring(2, 4), 16); // hexToG
    const b = parseInt(color.substring(4, 6), 16); // hexToB
    const uicolors = [r / 255, g / 255, b / 255];
    const c = uicolors.map((col) => {
      if (col <= 0.03928) {
        return col / 12.92;
      }
      return Math.pow((col + 0.055) / 1.055, 2.4);
    });
    const L = 0.2126 * c[0] + 0.7152 * c[1] + 0.0722 * c[2];
    return L > 0.55 ? "black" : "white";
  }

  /**
   * returns theme name by its id
   * @param themeId
   * @returns {string}
   */
  getThemeNameById(themeId) {
    if (!themeId || themeId === "undefined") {
      return "Kein Epic";
    } else {
      return this.themes[this.getThemeIndexById(themeId)].name;
    }
  }

  /**
   * returns index of themes-array by given theme id
   * @param themeID
   * @returns {number}
   */
  getThemeIndexById(themeID) {
    for (let k = 0; k < this.themes.length; k++) {
      if (this.themes[k]._id === themeID) {
        return k;
      }
    }
    return;
  }
}



// WEBPACK FOOTER //
// /agir/src/app/components/epic-selector/epic-selector.component.ts